import { notifications } from "@mantine/notifications"
import {
	IconCheck,
	IconExclamationCircle,
	IconCircleX
} from "@tabler/icons-react"
import {
	NOTIFICATION_COLORS,
	NOTIFICATION_DEFAULTS
} from "./notifications.types"
import type {
	NotificationType,
	NotificationConfig
} from "./notifications.types"
import styles from "./Notification.module.css"

const ICONS = {
	success: (color: string) => <IconCheck color={color} />,
	warning: (color: string) => <IconExclamationCircle color={color} />,
	error: (color: string) => <IconCircleX color={color} />
}

function getNotificationProps(
	type: NotificationType,
	title: string,
	message?: string,
	config?: Partial<NotificationConfig>
) {
	const notifColors = NOTIFICATION_COLORS[type]
	return {
		color: notifColors.color,
		icon: ICONS[type](notifColors.color),
		title: title,
		message: message,
		withCloseButton:
			config?.withCloseButton ?? NOTIFICATION_DEFAULTS.withCloseButton,
		autoClose: config?.autoClose ?? NOTIFICATION_DEFAULTS.autoClose,
		position: config?.position ?? NOTIFICATION_DEFAULTS.position,
		id: config?.id,
		style: {
			background: notifColors.background,
			border: `1px solid ${notifColors.color}`,
			color: notifColors.color,
			...config?.style
		},
		classNames: {
			root: styles.root,
			icon: styles.icon,
			closeButton: styles.closeButton,
			title: styles.text,
			description: styles.text
		}
	}
}

export function showSuccessNotification(
	title: string,
	message?: string,
	config?: Partial<NotificationConfig>
) {
	notifications.show(getNotificationProps("success", title, message, config))
}

export function showWarningNotification(
	title: string,
	message?: string,
	config?: Partial<NotificationConfig>
) {
	notifications.show(getNotificationProps("warning", title, message, config))
}

export function showErrorNotification(
	title: string,
	message?: string,
	config?: Partial<NotificationConfig>
) {
	notifications.show(getNotificationProps("error", title, message, config))
}
